<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="edit"
    max-width="600px"
    retain-focus
    v-on:click:outside="goToShow"
    v-on:keydown.esc="$router.push('/supplier')"
  >
    <v-card>
      <v-overlay absolute :value="this.dataloading || this.loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <v-card-title tabindex="-1">
        <span class="headline">Edit Supplier</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="editForm">
          <v-text-field
            :rules="validationRules.company_name"
            v-model="editFields.company_name"
            label="Company Name*"
            :error-messages="inputErrorMessages('company_name')"
            v-on:keyup.enter="saveSupplier"
            tabindex="1"
          />
          <v-text-field
            :rules="validationRules.contact_person"
            v-model="editFields.contact_person"
            label="Contact Person"
            :error-messages="inputErrorMessages('contact_person')"
            v-on:keyup.enter="saveSupplier"
            tabindex="2"
          />
          <v-text-field
            :rules="validationRules.email_address"
            v-model="editFields.email_address"
            label="Email Address*"
            :error-messages="inputErrorMessages('email_address')"
            v-on:keyup.enter="saveSupplier"
            tabindex="3"
          ></v-text-field>
          <v-text-field
            :rules="validationRules.contact_number"
            v-model="editFields.contact_number"
            label="Contact Numbers*"
            :error-messages="inputErrorMessages('contact_number')"
            v-on:keyup.enter="saveSupplier"
            tabindex="4"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.address"
            v-model="editFields.address"
            label="Address"
            :error-messages="inputErrorMessages('address')"
            v-on:keyup.enter="saveSupplier"
            tabindex="4"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.web_address"
            v-model="editFields.web_address"
            label="Web Address"
            :error-messages="inputErrorMessages('web_address')"
            v-on:keyup.enter="saveSupplier"
            tabindex="4"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.supplier_code"
            v-model="editFields.supplier_code"
            label="Supplier Code*"
            :error-messages="inputErrorMessages('supplier_code')"
            v-on:keyup.enter="saveSupplier"
            tabindex="4"
          ></v-text-field>
        </v-form>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveSupplier">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      validationRules: {
        company_name: [
          v => !!v || this.rem('Company name'),
          v => v.length <= 255 || 'Company name should not be greater than 255'
        ],
        contact_person: [v => v.length <= 255 || 'Contact person should not be greater than 255'],
        email_address: [
          v => !!v || this.rem('Email address'),
          v => v.length <= 255 || 'Email address should not be greater than 255',
          v => !v || /.+@.+/.test(v) || 'Email address must be valid'
        ],
        contact_number: [
          v => !!v || this.rem('Contact number'),
          v => v.length <= 255 || 'Contact numbers should not be greater than 255'
        ],
        address: [v => v.length <= 255 || 'Address should not be greater than 255'],
        web_address: [v => v.length <= 255 || 'Web address should not be greater than 100'],
        supplier_code: [
          v => !!v || this.rem('Supplier code'),
          v => v.length <= 255 || 'Company name should not be greater than 50'
        ]
      },
      errorMessages: {},
      editFields: {
        company_name: '',
        contact_person: '',
        email_address: '',
        contact_number: '',
        address: '',
        web_address: '',
        supplier_code: ''
      }
    };
  },
  computed: {
    ...mapState({
      dataloading: state => state.Supplier.getSupplierLoading,
      supplier(state) {
        if (typeof state.Supplier.supplier.data == 'undefined') {
          return {
            company_name: '',
            contact_person: '',
            email_address: '',
            contact_number: '',
            address: '',
            web_address: '',
            supplier_code: ''
          };
        }
        return state.Supplier.supplier.data;
      }
    })
  },
  watch: {
    supplier(value) {
      this.editFields.company_name = value.company_name;
      this.editFields.contact_person = value.contact_person;
      this.editFields.email_address = value.email_address;
      this.editFields.contact_number = value.contact_number;
      this.editFields.address = value.address;
      this.editFields.web_address = value.web_address;
      this.editFields.supplier_code = value.supplier_code;
    }
  },
  mounted() {
    this['Supplier/getSupplier']({ id: this.$route.params.id }).finally(() => {
      if (typeof this.$store.state.Supplier.supplier.data == 'undefined') {
        this.$router.push('/supplier');
        return;
      }
      this.editFields.company_name = this.$store.state.Supplier.supplier.data.company_name;
      this.editFields.contact_person = this.$store.state.Supplier.supplier.data.contact_person;
      this.editFields.email_address = this.$store.state.Supplier.supplier.data.email_address;
      this.editFields.contact_number = this.$store.state.Supplier.supplier.data.contact_number;
      this.editFields.address = this.$store.state.Supplier.supplier.data.address;
      this.editFields.web_address = this.$store.state.Supplier.supplier.data.web_address;
      this.editFields.supplier_code = this.$store.state.Supplier.supplier.data.supplier_code;
    });
    this.$refs.editForm.resetValidation();
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions(['Supplier/fetchSuppliers', 'Supplier/getSupplier']),
    clearCreate() {},
    rem(company_name) {
      return `${company_name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveSupplier() {
      if (this.$refs.editForm.validate()) {
        this.loading = true;
        axios
          .put(`api/v1/supplier/${this.$route.params.id}`, this.editFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Supplier saved',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['Supplier/fetchSuppliers']({ page: this.page });
            this.$router.push('/supplier');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    goToShow() {
      this.$router.push(`/supplier/${this.$route.params.id}`);
    }
  }
};
</script>